import React from 'react'
import { ATTextButtonProps } from './FormComponentProps'

const ATTextButton: React.FC<ATTextButtonProps> = ({
  onPressHandler,
  customClassName = '',
  title = '',
  disabled,
  isFilledButton = true,
  variant,
}) => {
  const getClassName = () => {
    let primaryClassName = ''
    if (variant === 'link') {
      primaryClassName = 'atlas-link-button'
    } else if (disabled) {
      primaryClassName = 'disabled-bordered-button '
    } else {
      primaryClassName = isFilledButton
        ? 'atlas-button '
        : 'atlas-bordered-button '
    }
    return primaryClassName + ' ' + customClassName
  }

  return (
    <button
      className={getClassName()}
      onClick={onPressHandler}
      data-toggle="tooltip"
      disabled={disabled}
      type="button"
    >
      {title}
    </button>
  )
}

export default ATTextButton
